import {
  Box,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

type SettingsKeysProps = {
  keys: string[]
  onDelete: (key: string) => void
}

// Format key to human-readable label
const formatKeyLabel = (key: string): string => {
  return key
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

const SettingsKeys = (props: SettingsKeysProps) => {
  const { keys, onDelete } = props

  if (keys.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
        No keys configured
      </Typography>
    )
  }

  return (
    <Stack spacing={0.5}>
      {keys.map((key) => {
        return (
          <Box
            key={key}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              py: 0.75,
              px: 1.5,
              borderRadius: 1,
              '&:hover': {
                bgcolor: 'action.hover',
              },
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Chip
                label={key}
                size="small"
                variant="outlined"
                sx={{
                  fontFamily: 'monospace',
                  fontSize: '0.75rem',
                  height: 24,
                }}
              />
              <Typography variant="body2" color="text.secondary">
                {formatKeyLabel(key)}
              </Typography>
            </Stack>
            <Tooltip
              title="Delete this key (use with caution)"
              placement="top"
            >
              <IconButton
                size="small"
                onClick={() => onDelete(key)}
                aria-label="delete"
                sx={{
                  color: 'text.secondary',
                  '&:hover': {
                    color: 'error.main',
                    bgcolor: 'error.lighter',
                  },
                }}
              >
                <DeleteOutlineIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </Box>
        )
      })}
    </Stack>
  )
}

export default SettingsKeys
